var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./info-modal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-11190fce\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./info-modal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home/components/info-modal/info-modal.vue
// module id = 263
// module chunks = 0